export default __webpack_public_path__ + "static/media/c2933581.d7ae9146.png";